module.exports = __WEBPACK_EXTERNAL_MODULE_142__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Vue","commonjs2":"vue","commonjs":"vue","amd":"vue"}
// module id = 142
// module chunks = 0